<template>
  <div class="table-container">
    <b-row>

      <b-col sm="7" xs="12">
        <slot name="CustomDropdown"></slot>
      </b-col>
      <b-col sm="12" xs="12" class="d-flex justify-content-end align-items-center">
        <slot name="dropdownfilter"></slot>
        <slot name="Add" v-if="addnewbtn"></slot>
        <span class="p-input-icon-left my-3 table-search" v-if="normaltablesearch">
          <i class="pi pi-search" />
          <InputText v-model="globalSearch" placeholder="Search" />
        </span>
      </b-col>

    </b-row>
    <DataTable :value="filteredData" v-model:selection="selectedProduct" editMode="cell" stripedRows showGridlines
      responsiveLayout="scroll" @update:selection="selectAllHandler" :metaKeySelection="true" selectionMode="single"
      @row-click="RowClick" @row-unselect-all="RowUnSelectAll" @row-unselect="RowUnSelect" @row-expand="onRowExpand"
      @row-collapse="onRowCollapse" v-model:expandedRows="expandedRows" :paginator="showPagination"
      :rows="state.pageSize" :rowsPerPageOptions="computedRowsPerPageOptions"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" @page="onPageChange"
      class="primevue-dtable tablepaginator">
      <template #empty>No data found.</template>

      <template>
        <Column expander style="width: 5rem" v-if="expandSubRows" class="field" />

        <Column header="#" headerStyle="width:3rem" v-if="seriaNlumber">
          <template #body="slotProps">
            {{ calculateSerialNumber(slotProps.index) }}
          </template>
        </Column>

        <!-- <Column selectionMode="multiple" v-if="selectionMode" :class="CheckDisabled"></Column> -->

        <Column selectionMode="multiple" v-if="selectionMode" class="normalcolumnfreezeleft1"
          :class="CheckDisabled, CheckDisabled == 'true' ? 'hideheadercheckbox' : ''">

          <template #body="{ data }">
            <Checkbox v-model="selectedProduct" :value="data" :disabled="data.disabled == true ? true : false" />
          </template>
        </Column>

        <Column v-for="column in columns" :key="column.field" :field="column.field" :header="column.header"
          :editable="column.editable" :slot="column.slot" :frozen="column.frozen" :frozenWidth="column.frozenWidth"
          :class="[column.class, column.frozencolumn ? 'columnfreeze' : '']" :selectionMode="column.selectionMode"
          :body-class="column.bodyclass" :hidden="column.hide">
          <template #body="{ data, index }">
            <span v-if="column.fieldDisplay != 'false'" :data-header="column.header" class="body-data"
              :title="data[column.field]">
              {{ data[column.field] }}
            </span>
            <span v-else :data-header="column.header" class="body-data">
              <slot :name="column.slot" :data="data" :header="column.header" :row-index="index" :on-change="(newValue) => updatedata(newValue, index, column.field)
                ">
              </slot>
            </span>
          </template>
        </Column>
      </template>
      <template #expansion="slotProps">
        <DataTable :value="SubList" responsiveLayout="scroll" class="py-4">
          <Column v-for="subCol in subColumns" :key="subCol.field" :field="subCol.field" :header="subCol.header" />
        </DataTable>
      </template>

      <template #footer>
        <slot name="Footer"></slot>
      </template>
    </DataTable>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType, watch } from "vue";
import { debounce } from "lodash";
import { boolean } from "yup";
class TrieNode {
  children: { [key: string]: TrieNode } = {};
  isEndOfWord: boolean = false;
}

class Trie {
  root: TrieNode;

  constructor() {
    this.root = new TrieNode();
  }

  insert(word: string) {
    let node = this.root;
    for (const char of word) {
      if (!node.children[char]) {
        node.children[char] = new TrieNode();
      }
      node = node.children[char];
    }
    node.isEndOfWord = true;
  }

  searchPrefix(prefix: string): TrieNode | null {
    let node = this.root;
    for (const char of prefix) {
      if (!node.children[char]) {
        return null;
      }
      node = node.children[char];
    }
    return node;
  }

  startsWith(prefix: string): boolean {
    return this.searchPrefix(prefix) !== null;
  }
}

export default defineComponent({
  name: "CustomDataTable",
  props: {
    value: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    selection: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    columns: {
      type: Array as PropType<any[]>,
      required: true,
    },
    selectionMode: {
      type: Boolean,
      default: false,
    },
    addnewbtn: {
      type: Boolean,
      default: false,
    },
    normaltablesearch: {
      type: Boolean,
      default: true,
    },
    footerVisible: {
      type: Boolean,
      default: false,
    },
    seriaNlumber: {
      type: Boolean,
      default: false,
    },
    CheckDisabled: {
      type: String,
      default: "false",
    },
    FromPage: {
      type: String,
      default: "",
    },
    expandSubRows: {
      type: Boolean,
      default: false,
    },
    SubList: {
      type: Array,
      default: () => [],
    },
    subColumns: {
      type: Array as PropType<any[]>,
      required: false,
    },
    paginator: {
      type: Boolean,
      default: false,
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
    state: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 25,
      }),
    },
  },
  setup(props, { emit }) {
    const computedRowsPerPageOptions = computed(() => {
      const defaultOptions = [25, 50, 100];
      // return [...defaultOptions, props.value.length];
      return [...defaultOptions];
    });

    const showPagination = computed(
      () => props.paginator && props.value.length > 25
    );

    const state = ref({
      currentPage: 1,
      pageSize: 25,
    });

    watch(
      () => props.state,
      (newValue) => {
        Object.assign(state.value, newValue);
      },
      { deep: true }
    );

    function onPageChange(event) {
      state.value.currentPage = event.page + 1;
      state.value.pageSize = event.rows;
      emit("page-change", state.value);
    }

    function calculateSerialNumber(index: number) {
      return (state.value.currentPage - 1) * state.value.pageSize + (index + 1);
    }

    const internalValue = ref(props.value);
    const selectedProduct = ref(props.selection);
    const globalSearch = ref("");

    watch(
      () => props.value,
      (newVal) => {
        internalValue.value = newVal;
      },
      { immediate: true }
    );

    watch(
      () => internalValue.value,
      (newVal) => {
        emit("update:value", newVal);
      }
    );

    watch(
      () => props.selection,
      (newVal) => {
        selectedProduct.value = newVal;
      },
      { immediate: true }
    );

    watch(
      () => selectedProduct.value,
      (newVal) => {
        emit("update:selection", newVal);
      }
    );

    const filteredData = computed(() => {
      if (!globalSearch.value) return internalValue.value;
      return internalValue.value.filter((item) =>
        Object.values(item).some((value) =>
          String(value).toLowerCase().includes(globalSearch.value.toLowerCase())
        )
      );
    });

    function updatedata(newValue: any, rowIndex: number, field: string) {
      internalValue.value[rowIndex][field] = newValue;
      emit("update:value", internalValue.value);
    }

    function selectAllHandler(event: any) {
      selectedProduct.value = event;
    }

    function RowClick(event: any) {
      emit("row-click", event);
    }

    function RowUnSelectAll(event: any) {
      emit("row-unselect-all", event);
    }

    function RowUnSelect(event: any) {
      emit("row-unselect", event);
    }

    const expandedRows: any = ref([]);

    const onRowExpand = (event: any) => {
      expandedRows.value = [event.data];
      emit("expandRows", event.data);
    };

    const onRowCollapse = (event: any) => {
      expandedRows.value = [];
      emit("collapseRows", event.data);
    };

    return {
      internalValue,
      selectedProduct,
      globalSearch,
      filteredData,
      updatedata,
      selectAllHandler,
      RowClick,
      RowUnSelectAll,
      RowUnSelect,
      onRowExpand,
      onRowCollapse,
      expandedRows,
      computedRowsPerPageOptions,
      state,
      onPageChange,
      calculateSerialNumber,
      showPagination,
    };
  },
});
</script>

<style lang="scss">
.table-container {
  .p-datatable {
    .p-datatable-tbody {
      tr {
        // height: 40px;

        &:nth-child(odd) {
          background-color: #f2f2f2;
        }

        td {
          vertical-align: middle;

          border-color: #c5c5c5;
        }
      }
    }

    .p-datatable-thead {
      background-color: #4caf50;

      color: #fff;

      font-weight: bold;

      th {
        color: rgb(31, 4, 4) !important;

        height: 50px;

        vertical-align: middle;

        border-color: #c5c5c5;

        &:first-child {
          border-top-left-radius: 5px;
        }

        &:last-child {
          border-top-right-radius: 5px;
        }
      }
    }
  }

  .disableclass {
    pointer-events: none;
    opacity: 0.5;
  }

  // .editable {

  //   color: blue !important;

  // }
}

.columnfreeze {
  position: sticky;
  right: -16px;
  z-index: 1;
  width: 40px !important;
  //text-align-last: center;
  background-color: #e1e1e1;
}

.columnfreezeright {
  position: sticky;
  right: 10px;
  z-index: 1;
  width: 40px !important;
  //text-align-last: center;
  background-color: #e1e1e1;
}

.columnfreezeleft {
  position: sticky;
  left: -16px;
  z-index: 1;
  width: 40px !important;
  //text-align-last: center;
  background-color: #e1e1e1;
}

.hideheadercheckbox {
  .p-column-header-content {
    .p-checkbox {
      pointer-events: none;
      opacity: 0.5;
    }
  }
}

.normalcolumnfreezeleft1 {
  position: sticky;
  left: -16px;
  z-index: 1;
  width: 40px !important;
  //text-align-last: center;
  background-color: #e1e1e1;
}

.normalcolumnfreezeleft2 {
  position: sticky;
  left: 24px;
  z-index: 1;
  width: 40px !important;
  // text-align-last: center;
  background-color: #e1e1e1;
}

.normalcolumnfreezeleft3 {
  position: sticky;
  left: 84px;
  z-index: 1;
  width: 140px !important;
  // text-align-last: center;
  background-color: #e1e1e1;
}

.normalcolumnfreezeleft4 {
  position: sticky;
  left: 144px;
  z-index: 1;
  width: 140px !important;
  // text-align-last: center;
  background-color: #e1e1e1;
}

// Pagination styles
.p-paginator {
  background: #ffffff !important;
  border: solid #e1e1e1 !important;
  border-width: 1px !important;
  border-radius: 0px !important;
}

.p-paginator-bottom {
  display: flex;
  justify-content: center;
  background: #ffffff;
}

.p-paginator .p-paginator-pages .p-paginator-page {
  min-width: 2rem !important;
  height: 2rem !important;
}

.p-paginator .p-paginator-first,
.p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next,
.p-paginator .p-paginator-last {
  min-width: 2rem !important;
  height: 2rem !important;
}

.pagination-text {
  color: #999999;
  font-size: 14px;
  font-weight: 400;
}

.pagination-dropdown {
  margin-bottom: 0px !important;
}

.pagination-dropdown .p-inputtext {
  padding: 0.5rem 0.1rem 0.5rem 0.5rem !important;
  color: #999999;
  font-size: 14px;
  font-weight: 400;
}

.pagination-dropdown .p-dropdown .p-dropdown-trigger {
  width: 2rem;
}

.p-paginator .p-dropdown .p-dropdown-trigger {
  width: 1rem;
  padding-right: 15px;
}

.tablepaginator .p-paginator .p-inputtext {
  padding: 7px !important;
}

.tablepaginator .p-paginator .p-dropdown {
  height: 2rem;
  width: 57px;
}

@media only screen and (max-width: 450px) {

  .p-paginator .p-paginator-first,
  .p-paginator .p-paginator-prev,
  .p-paginator .p-paginator-next,
  .p-paginator .p-paginator-last,
  .p-paginator .p-paginator-pages .p-paginator-page {
    min-width: 1rem !important;
    height: 1rem !important;
  }

  .p-paginator .p-paginator-current {
    min-width: 1rem;
    height: 1rem;
    font-size: 12px;
  }

  .tablepaginator .p-paginator .p-dropdown {
    height: 25px;
    width: 35px;
  }

  .tablepaginator .p-paginator .p-inputtext {
    padding: 5px 2px;
    font-size: 12px;
  }

  .p-paginator .p-paginator-pages .p-paginator-page {
    font-size: 12px;
  }

  .p-paginator .p-dropdown .p-dropdown-trigger {
    width: 0.5rem;
    padding-right: 8px;
  }

  .p-paginator .pi {
    font-size: 10px;
  }
}

//NewColumnFreezeClass
$columnWidths: (
  140px,
  140px,
  140px,
  194px,
  140px
); // Define column widths
$leftValue: (
  -18px,
  65px,
  135px,
  240px,
  392px
); //  left values

@for $i from 1 through length($columnWidths) {
  .newcolumnfreezeleft#{$i} {
    position: sticky;
    left: nth($leftValue, $i);
    z-index: 1;
    width: nth($columnWidths, $i) !important;
    background-color: #e1e1e1;
  }


}

//NewColumnFreezeClass</style>
